export class SchemaFormCheckboxController {
  public ngModel: any;

  /**
   * A method which gets invoked when a checkbox on the schema form is clicked and sets an inverted value of the current value
   */
  public checkboxChanged = () => {
    const currentValue = this.ngModel[0].$modelValue;

    this.ngModel[0].$setViewValue(!currentValue);
    this.ngModel[0].$commitViewValue();
  }
}